import React, { Component } from 'react'
import PropTypes from 'prop-types'
import NumberFormat from 'react-number-format'
import { midas } from '@resurs/midas'
import { Conditional } from '@resurs/react-utils'
import { Button, Column, Columns } from '@resurs/midas-react'
import PageWrapper from '../../../../internal/PageWrapper'
import { getText } from '../../../../internal/TextLabels'
import { inspectionAnimation } from '../../../../assets/animations'
import { MerchantEventStream } from '../shared/MerchantEventStream'

class PaymentInspectionPage extends Component {
  constructor(props) {
    super(props)

    this.merchantEventStatusStream = new MerchantEventStream(
      this.handleEvent,
      this.props.data.payment.paymentResult.id,
    )
  }

  componentWillUnmount() {
    this.merchantEventStatusStream.stop()
  }

  handleEvent = event => {
    if (event.type === 'AWAITING_API_ACTION' || event.type === 'REJECTED') {
      this.props.onNext()
    }
  }

  render() {
    const { data, onCancel } = this.props
    return (
      <>
        <PageWrapper type="warning">
          <div
            style={{
              padding: '2rem',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <div style={{ display: 'flex' }}>
              <img
                style={{ margin: '1rem' }}
                src={inspectionAnimation}
                alt="Inspection animation"
              />
              <h4 style={{ margin: '2.2rem 1rem 0 0' }}>
                {getText('payApply.paymentInspection.title')}
              </h4>
              <div
                style={{ display: 'inline-block', marginLeft: '20px' }}
                className={midas.loading}
              />
            </div>
            <Columns>
              <Column col6>
                <div style={{ paddingRight: '4rem', paddingLeft: '5rem' }}>
                  {getText('payApply.paymentInspection.description1')}
                </div>
                <div
                  style={{
                    paddingRight: '4rem',
                    marginTop: '2rem',
                    paddingLeft: '5rem',
                  }}
                >
                  {getText('payApply.paymentInspection.description2')}
                </div>
                <Conditional
                  when={data.payment.paymentResult.store.country !== 'DK'}
                >
                  <div style={{ marginTop: '3rem', paddingLeft: '5rem' }}>
                    <Columns>
                      <Column col6>
                        <strong>
                          {getText('payApply.paymentInspection.mupId')}
                        </strong>
                      </Column>
                      <Column col6>
                        <strong>
                          <NumberFormat
                            value={data.payment.paymentResult.application.mupId}
                            displayType="text"
                            format="### ### ###"
                          />
                        </strong>
                      </Column>
                    </Columns>
                  </div>
                </Conditional>
              </Column>
              <Conditional
                when={data.payment.paymentResult.store.country !== 'DK'}
              >
                <Column col6>
                  <Columns>
                    <Conditional
                      when={data.payment.paymentResult.store.country !== 'FI'}
                    >
                      <Column col12 noPadding>
                        {getText('payApply.paymentInspection.support.info')}
                      </Column>
                      <Column col12 />
                    </Conditional>
                    <Column col6 noPadding>
                      {getText(
                        'payApply.paymentInspection.support.phone.title',
                      )}
                    </Column>
                    <Column col6 noPadding>
                      {getText(
                        'payApply.paymentInspection.support.phone.number',
                      )}
                    </Column>
                    <Column col6 noPadding>
                      {getText('payApply.paymentInspection.support.open.title')}
                    </Column>
                    <Column col6 noPadding>
                      {getText('payApply.paymentInspection.support.open.hours')
                        .split(',')
                        .map(text => (
                          <div key={text}>{text}</div>
                        ))}
                    </Column>
                  </Columns>
                </Column>
              </Conditional>
            </Columns>
          </div>
        </PageWrapper>
        <PageWrapper>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              padding: '2rem',
            }}
          >
            <Button onClick={() => onCancel()}>
              {getText('payApply.restart')}
            </Button>
          </div>
        </PageWrapper>
      </>
    )
  }
}

PaymentInspectionPage.propTypes = {
  data: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
}

export default PaymentInspectionPage
